import type { ElementType, FC, ReactNode } from 'react'

import { useSiteContent } from '@/lib/site-content'

interface CmsTextProps {
    textKey: string
    as?: ElementType
    id?: string
    className?: string
    value?: string
}

// One row of the site_texts collection, rendered as visible text and tagged with
// data-mdlfy-cms so it can be edited straight from the preview.
const CmsText: FC<CmsTextProps> = ({
    textKey,
    as: Tag = 'span',
    id,
    className,
    value
}): ReactNode => {
    const { texts } = useSiteContent()
    const entry = texts[textKey]

    if (!entry) return null

    return (
        <Tag
            id={id}
            className={className}
            value={value}
            data-mdlfy-cms={`site_texts:${entry.id}:value`}
        >
            {entry.value}
        </Tag>
    )
}

export default CmsText
